exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#dsModalLogo[data-v-45042976]{border:3px solid #fff;width:70px;height:70px;border-radius:100%;box-shadow:0 0 0 1px rgba(0,0,0,0.18),0 2px 2px 0 rgba(0,0,0,0.08)\n}\n#dsModalLogo .Header-logoImage[data-v-45042976]{width:64px;height:64px;margin:1px;border-radius:100%;background:#fff;background-position-x:0%;background-position-y:0%;background-image:none;background-size:auto auto;background-position:50% 50%;background-size:cover;display:inline-block\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45042976","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GlobalSettings/settings/setLogo.vue
// module id = 404
// module chunks = 0